import {UI} from "../../../../stem-core/ui/UIBase";
import {UserSession} from "../../../../client/state/UserSessionStore.js";
import {ArrayPaginator} from "../../../../stem-core/state/pagination/EndpointPaginator";
import {SimpleTable} from "../../../../dashboard/ui/SimpleTable.jsx";
import {Card} from "../../ui/Card.jsx";
import type {AdminUser} from "../../../../client/state/AdminUserStore.js";


interface UserSessionsListOptions {
    user?: AdminUser;
}

export class UserSessionsList extends UI.Element<UserSessionsListOptions> {
    render() {
        const {user} = this.options;
        const userSessions = UserSession.filterBy({userId: user.id});
        const paginator = new ArrayPaginator(userSessions, 8);

        const columns = [
            ["Id", (userSession: UserSession) => userSession.id],
            ["Created", (userSession: UserSession) => userSession.createdAt],
            ["Ip", (userSession: UserSession) => userSession.ip],
            ["Source", (userSession: UserSession) => userSession.source],
            ["Social Provider", (userSession: UserSession) => userSession.provider],
            ["Country", (userSession: UserSession) => userSession.countryCode],
            ["Expire date", (userSession: UserSession) => userSession.expiresAt],
            ["Logged out date", (userSession: UserSession) => userSession.revokedAt],
            ["Origin", (userSession: UserSession) => userSession.originMerchant],
            ["Shared with", (userSession: UserSession) => userSession.sharedWithMerchant],
        ];

        return (
            <Card title="Sessions">
                <SimpleTable columns={columns} paginator={paginator}/>
            </Card>
        );
    }
}
